import React, { useState } from "react";
import { Box, Button, Divider } from "@mui/material";

import AlternateSearchBars from "../../components/Custome/AlternateSearchBars";
import Alert from "../../components/Custome/Alert";
import StatusLinearProgressBar from "../../components/Custome/StatusLinearProgressBar";
import CircularProgressIndicator from "../../components/Custome/CircularProgressIndicator";
import FilterDropdown from "../../components/Custome/FilterDropdown";
import BreadcrumbLine from "../../components/Custome/BreadcrumbLine";
import TabButton from "../../components/Custome/TabButton";
import ExpandedRadioButton from "../../components/Custome/ExpandedRadioButton";
import Scrim from "../../components/Custome/Scrim";
import SideDrawer from "../../components/Custome/SideDrawer";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import TableComp from "../../components/Table";
import AllOppCard from "../../components/AllOppCard";

import DeploymentWidget from "../../components/DeploymentWidget";

import Table from "../../components/Table";

import DProgress from "../../components/dprogress";
import FileUploaded from "../../components/Custome/FileUploaded";
import FileUpload from "../../components/MUI/FileUpload";
import CardTamplate from "../../components/Custome/CardTamplate";
import EmploymentHistoryCard from "../../components/Custome/EmploymentHistoryCard";
import DeploymentRoleCategoryCard from "../../components/Custome/DeploymentRoleCategoryCard";
import PastProjectCard from "../../components/Custome/PastProjectCard";

const Cst = () => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [drawerVariant, setDrawerVariant] = useState("default");

  const handleOpenDrawer = (variant) => {
    setDrawerVariant(variant);
    setDrawerOpen(true);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      marginTop="20px"
      gap="20px"
      height="80vh"
    >
      <Divider />
      <AlternateSearchBars />
      <Divider />
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        <Alert variant="info" />
        <Alert variant="success" />
        <Alert variant="warning" />
        <Alert variant="error" />
        <Alert variant="neutral" />
      </Box>
      <Divider />
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        <StatusLinearProgressBar variant="high" value={85} />
        <StatusLinearProgressBar variant="medium" value={50} />
        <StatusLinearProgressBar variant="low" value={25} />
      </Box>
      <Divider />
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        <CircularProgressIndicator variant="" value={85} />
        <CircularProgressIndicator variant="dot" value={50} />
        <CircularProgressIndicator variant="text" value={25} />
      </Box>
      <Divider />
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        <FilterDropdown
          variant="enabled"
          label="Enabled"
          value="all"
          onChange={() => {}}
        />
        <FilterDropdown
          variant="disabled"
          label="Disabled"
          value="all"
          onChange={() => {}}
        />
        <FilterDropdown
          variant="hovered"
          label="Hovered"
          value="all"
          onChange={() => {}}
        />
        <FilterDropdown
          variant="focused"
          label="Focused"
          value="all"
          onChange={() => {}}
        />
      </Box>
    
      <Divider />
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        <CardTamplate variant="default" />
        <CardTamplate variant="list" />
        <CardTamplate variant="radio" />
        <CardTamplate variant="grid" />
        <CardTamplate variant="subtable" />
        <CardTamplate variant="button" />
      </Box>
      <Divider />
      <EmploymentHistoryCard />
      <Divider />
      <DeploymentRoleCategoryCard />
      <Divider />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
          gap: 2,
        }}
      >
        <PastProjectCard variant="myProfileCollapsed" />
        <PastProjectCard variant="myProfileExpanded" />
        <PastProjectCard variant="customerCollapsed" />
        <PastProjectCard variant="customerExpanded" selected />
      </Box>
      <Divider />
      <Box
        sx={{
          backgroundColor: "gray",
          padding: "20px",
          display: "flex",
          gap: 2,
          flexDirection: "column",
        }}
      >
        <BreadcrumbLine variant="Back/Forward" />
        <BreadcrumbLine variant="No Back/Forward" />
        <BreadcrumbLine variant="Back/No Forward" />
      </Box>
      <Divider />
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        <TabButton variant="enabled" type="icon" />
        <TabButton variant="hovered" type="iconText" label="Label" />
        <TabButton variant="selected" type="text" label="Label" />
        <TabButton variant="disabled" type="iconText" label="Label" />
      </Box>
      <Divider />

      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
        <ExpandedRadioButton
          variant="enabled"
          headline="Headline"
          description="Description"
        />
        <ExpandedRadioButton
          variant="hovered"
          headline="Headline"
          description="Description"
        />
        <ExpandedRadioButton
          variant="selected"
          headline="Headline"
          description="Description"
        />
        <ExpandedRadioButton
          variant="completed"
          headline="Headline"
          description="Description"
        />
        <ExpandedRadioButton variant="enabled" headline="Headline" noContent />
      </Box>
      <Divider />
      <FileUpload />
      <Divider />
      <FileUploaded />
      <Divider />
      <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
        <Button variant="contained" onClick={() => handleOpenDrawer("default")}>
          Default
        </Button>
        <Button
          variant="contained"
          onClick={() => handleOpenDrawer("trailingIcon")}
        >
          Trailing Icon
        </Button>
        <Button
          variant="contained"
          onClick={() => handleOpenDrawer("closeButton")}
        >
          Close Button
        </Button>
        <Button
          variant="contained"
          onClick={() => handleOpenDrawer("closeButtonWithIcon")}
        >
          Close + Icon
        </Button>
      </Box>
      <SideDrawer
        open={drawerOpen}
        size="medium"
        variant={drawerVariant}
        title="Side Drawer Title"
        content={null}
        trailingIcon={
          drawerVariant === "trailingIcon" ||
          drawerVariant === "closeButtonWithIcon" ? (
            <InfoOutlinedIcon />
          ) : null
        }
        onClose={() => setDrawerOpen(false)}
      />
      <Divider />
      <TableComp />

      <Divider />
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
        <AllOppCard
          role="Software Engineer"
          location="Remote"
          startDate="Apr 1, 2026"
          endDate="Oct 1, 2026"
          rate="$80/hr"
          tAndE="Yes"
          applicants="12 applicants"
          description="Exciting project in AI/ML."
        />

        <DeploymentWidget
          projectId="P-123456"
          projectName="Apollo"
          clientName="SpaceX"
          startDate="Mar 1, 2026"
          endDate="Sep 1, 2026"
          address="123 Mars Ave, Red City"
          role="Lead Developer"
          rate="$150/hr"
          laborId="CLIN 02.1, Dev Work"
          teId="CLIN 02.2, Travel"
          hoursLeft={100}
          totalHours={1000}
        />

        <Table
          columns={[
            { id: "col1", label: "Column 1" },
            { id: "col2", label: "Column 2" },
            { id: "col3", label: "Column 3" },
            { id: "col4", label: "Column 4" },
            { id: "col5", label: "Column 5" },
          ]}
          row={[
            {
              id: 1,
              col1: "Row 1 Col 1",
              col2: "Row 1 Col 2",
              col3: "Row 1 Col 3",
              col4: "Row 1 Col 4",
              col5: "Row 1 Col 5",
            },
            {
              id: 2,
              col1: "Row 2 Col 1",
              col2: "Row 2 Col 2",
              col3: "Row 2 Col 3",
              col4: "Row 2 Col 4",
              col5: "Row 2 Col 5",
            },
            {
              id: 3,
              col1: "Row 3 Col 1",
              col2: "Row 3 Col 2",
              col3: "Row 3 Col 3",
              col4: "Row 3 Col 4",
              col5: "Row 3 Col 5",
            },
            {
              id: 4,
              col1: "Row 4 Col 1",
              col2: "Row 4 Col 2",
              col3: "Row 4 Col 3",
              col4: "Row 4 Col 4",
              col5: "Row 4 Col 5",
            },
            {
              id: 5,
              col1: "Row 5 Col 1",
              col2: "Row 5 Col 2",
              col3: "Row 5 Col 3",
              col4: "Row 5 Col 4",
              col5: "Row 5 Col 5",
            },
          ]}
          sorting={true}
          pagination={true}
          rowSelection={true}
          allSelect={true}
          isEdit={true}
          isDelete={true}
          onEdit={(row) => alert(`Edit row ${row.id}`)}
          onDelete={(id) => alert(`Delete row ${id}`)}
          multipleSelect={true}
        />
        <DProgress />
      </Box>
      <Divider />

      <Scrim />
    </Box>
  );
};

export default Cst;
